module.exports = "/_next/static/files/0ff3067031303ef7be5e7ffc06d568b4.jpg";